import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';

/**
 * Wraps the /admin/login route.
 * - If the visitor is already authenticated as admin → skip login, go straight to /admin.
 * - Otherwise render the outlet (AdminLoginPage).
 */
const AdminAuthLayout = () => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user?.user_type === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default AdminAuthLayout;
